// import { log_click } from '../config'
import maps from './map'
const log_click = 'data-click'
let logMap = new maps()
/**
 * 递归寻找DOM节点的data-log属性
 * @param {*} el DOM节点
 */
function getNode(el, fn, dom) {
    if (el === document || !el) return '';
    let ATTR = el.getAttribute(log_click) || el.getAttribute(`${log_click}-stop`);
    if(ATTR){
        fn(ATTR, 'click');
        return ;
      }
    // 寻找父级元素的data-log属性
    dom !== el && getNode(el.parentNode, fn, dom)
}
/**
 * 处理DOM节点事件回调处理
 * @param {*} event 点击事件节点数据
 * @param {*} fn 回调函数
 */
function eventHandle(event, fn, dom) {
  try {
    event = event || window.event
    getNode(event.target, fn, dom)
  } catch (error) {
    console.log(error)
  }
}
// 给页面添加点击事件
function setCallBack(event, fn, dom) {
  window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
  eventHandle(event, fn, dom)
}
export function addClickEvent(fn) {
    try {
        let node = document.querySelectorAll(`[${log_click}-stop]`)
        for (let i = 0; i < node.length; i++) {
            let dom = node[i]
            if (logMap.get(dom)) continue;
            logMap.set(dom, true)
            if (dom.addEventListener) {
            // 给DOM节点添加事件绑定
                dom.addEventListener('click', (event) => {
                    setCallBack(event, fn, dom)
                })
            } else if (window.attachEvent) {
            // 给DOM节点添加事件绑定,兼容IE
                dom.attachEvent('onclick', (event) => {
                    setCallBack(event, fn, dom)
                })
            } else {
                console.log('请升级您的浏览器版本！')
            }
        } 
    } catch (error) {
        console.log(error);    
    }
}
/**
 * 给body元素添加时间监听
 * @param {*} fn 回调函数
 */
function eventCall(dom, fn) {
    addClickEvent(fn)
    if (dom.addEventListener) {
        // 给DOM节点添加事件绑定
        dom.addEventListener('click', (e) => {
            eventHandle(e, fn, dom)
        })
    } else if (window.attachEvent) {
        // 给DOM节点添加事件绑定,兼容IE
        dom.attachEvent('onclick', (e) => {
            eventHandle(e, fn, dom)
        })
    } else {
        console.log('请升级您的浏览器版本！')
    }
}
export default function(fn) {
    try {
        const dom = document.getElementsByTagName('body')[0]
        eventCall(dom, fn)
    } catch (error) {
        addEventListener('load', function() {
            const dom = document.getElementsByTagName('body')[0]
            eventCall(dom, fn)
        })
    }
}
